import {
  userRepository,
  useUserStore,
  changeUserSettingsUseCase,
  type UserSelected,
  type UserChange,
} from '~/domains/user';
import { useSnackbarNotificationService } from '~/domains/core';
import { useI18n } from '~/infrastructure';

const useChangeUserSettingsAdapter = (): {
  changeUserSettings: (
    settings: UserSelected,
  ) => Promise<UserChange | undefined>;
} => {
  const { setUserSelected } = useUserStore();
  const { t } = useI18n();
  const { notifyError } = useSnackbarNotificationService();

  const changeUserSettings = async (
    settings: UserSelected,
  ): Promise<UserChange | undefined> => {
    return await changeUserSettingsUseCase(settings, {
      notifier: {
        notifyError: () => {
          notifyError(t('common.error.somethingWentWrong'));
        },
      },
      userRepository,
      storage: {
        setUserSelected,
      },
    });
  };

  return {
    changeUserSettings,
  };
};

export default useChangeUserSettingsAdapter;
